import { render, staticRenderFns } from "./WithdrawView.vue?vue&type=template&id=24fd7a06&scoped=true&"
import script from "./WithdrawView.vue?vue&type=script&lang=js&"
export * from "./WithdrawView.vue?vue&type=script&lang=js&"
import style0 from "./WithdrawView.vue?vue&type=style&index=0&id=24fd7a06&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24fd7a06",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
